export const de = {
  navigation: {
    home: 'Start',
    stocks: 'Aktien',
    evaluations: 'Signalauswertung',
    login: 'Login',
    logout: 'Abmelden',
    openMenu: 'Navigation öffnen',
    mobileMenu: 'Mobile Navigation',
  },
  settings: {
    open: 'Einstellungen öffnen',
    language: 'Sprache',
    german: 'Deutsch',
    english: 'Englisch',
  },
  onboarding: {
    title: 'Wertpapiere importieren',
    adminOnly: 'Nur Administratoren dürfen Wertpapiere importieren.',
    description:
      'Suche nach ISIN oder Symbol. Unterstützt werden Aktien in den USA und auf XETRA. Die Suche startet noch keinen Import.',
    search: 'ISIN oder Symbol',
    find: 'Suchen',
    loading: 'Auftrag wird verarbeitet',
    noResults: 'Kein passender, unterstützter Börsenplatz gefunden.',
    review: 'Import prüfen',
    existing: 'Bereits im Datenbestand',
    confirmTitle: 'Import bestätigen',
    cancel: 'Abbrechen',
    confirm: 'Importieren und berechnen',
    history:
      'Gesamte verfügbare EOD-Historie bis heute; Tages-, Wochen- und Monatsindikatoren samt Signalen nach den bestehenden Regeln.',
    cost: 'Konservative Obergrenze je Versuch: {{count}} Provider-Kontingenteinheiten für Kurse und Kalender, einschließlich HTTP-Wiederholungen. Höchstens drei Jobversuche; vorhandene Kalender verringern den Verbrauch. Suche und spätere automatische Aktualisierungen benötigen zusätzlich Kontingent.',
    autoUpdate:
      'Nach abgeschlossenem Import wird das Wertpapier in die automatische Aktualisierung aufgenommen.',
    quality:
      'Fehlende Daten werden nicht ergänzt. Unvollständige Perioden und zu kurze Historie werden ausgewiesen. Preisbasis: bestehende unbereinigte OHLC-Daten; analytische Signale sind keine Anlageberatung.',
    started:
      'Der Hintergrundauftrag wurde angenommen. Du kannst diese Seite verlassen und den Status später wieder aufrufen.',
    jobs: 'Importaufträge',
    noJobs: 'Noch keine Importaufträge vorhanden.',
    draft: 'Bestätigung ausstehend',
    queued: 'In Warteschlange',
    running: 'In Bearbeitung',
    waiting: 'Wartet auf Kontingent',
    complete: 'Abgeschlossen',
    partial: 'Mit Einschränkungen abgeschlossen',
    failed: 'Fehlgeschlagen',
    entities: 'Wertpapier wird angelegt',
    dailyEod: 'Historische Tageskurse werden importiert',
    dailyIndicators: 'Tagesindikatoren und Signale werden berechnet',
    derivedTimeframes: 'Wochen- und Monatsdaten werden berechnet',
    finished: 'Bearbeitung beendet',
    quota:
      'Provider-Kontingent ist unzureichend oder derzeit nicht verlässlich prüfbar. Der Auftrag wartet und wird erneut geprüft; zusätzliche Kontingente werden nicht automatisch gekauft.',
    updated: 'Zuletzt aktualisiert',
    finishedNotice: 'Dein Importauftrag ist beendet:',
    markRead: 'Gelesen',
    open: 'Analyse öffnen',
    notifications: '{{count}} Importaufträge sind beendet. Ergebnisse ansehen.',
    summary:
      'Tagesbeobachtungen: {{observations}} · abgewiesene Kurse: {{rejected}} · Signale: {{signals}} · unvollständige Perioden: {{incomplete}} · Berechnungsfehler: {{failures}} · zu kurze Historie: {{warmup}}',
    error: 'Die Anfrage konnte nicht abgeschlossen werden. Bitte erneut versuchen.',
    statusError:
      'Der aktuelle Auftragsstatus konnte nicht geladen werden. Angezeigte Ergebnisse können veraltet sein.',
    planExpired: 'Die Bestätigung ist abgelaufen. Bitte erneut suchen.',
    conflict: 'Der Börsenplatz widerspricht vorhandenen Stammdaten. Bitte prüfen lassen.',
    queueBusy:
      'Ein Import läuft bereits oder die Warteschlange ist voll. Bitte die Aufträge prüfen und später erneut versuchen.',
    searchLimit: 'Bitte einige Sekunden bis zur nächsten Suche warten.',
    failedHelp:
      'Der Auftrag konnte nicht vollständig verarbeitet werden. Vor einem neuen Versuch Ursache und Provider-Verfügbarkeit prüfen lassen.',
    permissionRevoked:
      'Der Auftrag wurde nicht ausgeführt, weil die Administratorberechtigung nicht mehr besteht.',
  },
  auth: {
    login: 'Login',
    email: 'E-Mail',
    password: 'Passwort',
    signIn: 'Anmelden',
    invalidCredentials: 'Ungültige E-Mail-Adresse oder ungültiges Passwort.',
    loading: 'Anmeldung wird geprüft …',
    loggingOut: 'Abmeldung läuft …',
    logoutFailed: 'Abmeldung fehlgeschlagen.',
    logoutUnconfirmed:
      'Du bist in diesem Browser abgemeldet. Die Abmeldung am Server konnte nicht bestätigt werden.',
    inactivityWarning: 'Deine Sitzung läuft bald ab',
    inactivityCountdown: 'Du wirst wegen Inaktivität in {{seconds}} Sekunden abgemeldet.',
    keepSession: 'Angemeldet bleiben',
    inactivityExpired:
      'Du wurdest nach fünf Minuten Inaktivität abgemeldet. Bitte melde dich erneut an.',
  },
  stock: {
    title: 'Aktienanalyse',
    select: 'Aktie auswählen',
    timeframe: 'Zeitraum',
    loading: 'Analysedaten werden geladen',
    entriesError: 'Aktien konnten nicht geladen werden.',
    analysisError: 'Analysedaten konnten nicht geladen werden.',
    noEntries: 'Keine unterstützten Aktien verfügbar.',
    source: 'Quelle',
    unavailable: 'Nicht verfügbar',
    updated: 'Stand',
    stale: 'Daten möglicherweise veraltet',
    noObservations: 'Für diesen Zeitraum liegen keine Kursdaten vor.',
    signal: 'Analytisches Signal',
    lastUpdate: 'Letzte Aktualisierung',
    recent: 'Letzte Beobachtungen',
    partial: 'Kursdaten sind vorhanden, Indikatoren fehlen jedoch teilweise.',
    disclaimer:
      'Analytisches Signal – keine Anlageberatung. Die Angaben dienen nur Analysezwecken und garantieren keine zukünftige Entwicklung.',
    chartLabel: 'Kurs- und Indikatorverlauf für {{symbol}}',
    chartSeries: 'Datenreihen auswählen',
    chartSignals: 'Signale anzeigen',
    chartTriggers: 'Auslöser',
    chartBuy: 'Kauf',
    chartSell: 'Verkauf',
    chartSuperSignals: 'SUPER CALL / SUPER PUT',
    inspectChart: 'Chart-Datenpunkt auswählen',
    enterChartFullscreen: 'Chart im Vollbild anzeigen',
    exitChartFullscreen: 'Vollbildansicht des Charts beenden',
    signalHistory: 'Signale im gewählten Zeitraum',
    noSignals: 'Für diesen Zeitraum liegen keine Signale vor.',
    instrumentPanel: 'Indizes und Aktien',
    favorites: 'Favoriten',
    filterFavorites: 'Favoriten filtern',
    noFavorites: 'Keine Favoriten vorhanden.',
    addFavorite: 'Zu Favoriten hinzufügen',
    removeFavorite: 'Aus Favoriten entfernen',
    favoriteUpdateFailed: 'Favorit konnte nicht gespeichert werden.',
    indices: 'Indizes',
    noIndices: 'Keine Indizes verfügbar.',
    stockPanel: 'Aktien',
    filterStocks: 'Aktien filtern',
    openStockPanel: 'Aktienpanel öffnen',
    closeStockPanel: 'Aktienpanel schließen',
    noStockMatches: 'Keine passenden Aktien gefunden.',
    longSignal: 'KAUFSIGNAL',
    shortSignal: 'VERKAUFSSIGNAL',
    leavingLongSignal: 'LONG-SIGNAL BEENDET',
    leavingShortSignal: 'SHORT-SIGNAL BEENDET',
    noCurrentSignal: 'KEIN AKTUELLES SIGNAL',
    superCall: 'SUPER CALL',
    superPut: 'SUPER PUT',
    provisional: 'vorläufig',
    provisionalNotice:
      'Enthält vorläufige Stundenwerte aus verzögerten Live-Kursen (Hoch/Tief angenähert); sie werden nachts durch die offiziellen Werte ersetzt.',
    noSuperSignal: 'KEIN SUPER-SIGNAL',
    combinedSignal: 'Kombiniertes Signal',
    infoSignal: 'Info',
    timeframe30m: '30 Min.',
    timeframe3h: '3 Std.',
    timeframe6h: '6 Std.',
    timeframe1h: 'Stündlich',
    timeframe1d: 'Täglich',
    timeframe1w: 'Wöchentlich',
    timeframe1mo: 'Monatlich',
  },
  dashboard: {
    favorites: 'Favoriten',
    indices: 'Indizes',
    stocks: 'Aktien',
    loading: 'Signale werden geladen',
    empty: 'Keine Tagessignale verfügbar.',
    emptyCombined: 'Keine SUPER-Signale verfügbar.',
    showSingleSignals: 'Einzelsignale anzeigen',
    error: 'Signale konnten nicht geladen werden.',
    stale: 'Signal möglicherweise veraltet',
    pagination: 'Seiten für {{section}}',
    index: 'Index',
    openDetails: 'Details für {{name}} ({{symbol}}) öffnen',
  },
  providerStatus: {
    title: 'EODHD API-Kontingent',
    loading: 'API-Kontingent wird geladen',
    healthy: 'API-Kontingent verfügbar',
    warning: 'API-Kontingent wird knapp',
    exhausted: 'API-Kontingent ist aufgebraucht',
    unavailable: 'API-Kontingent kann derzeit nicht geprüft werden.',
    used: 'Heute verbraucht',
    remaining: 'Heute verbleibend',
    dailyLimit: 'Tageslimit',
    extra: 'Zusatzkontingent',
    previousUsageDate:
      'EODHD meldet noch den Stand vom {{date}}. Der heutige Verbrauch beginnt laut Anbieter beim ersten kostenpflichtigen Aufruf.',
    timestamps: 'Geprüft: {{checked}} · Tagesreset: {{reset}}',
    unknown: 'unbekannt',
  },
  evaluation: {
    title: 'Signalauswertung',
    description: 'Historische Entwicklung nach analytischem Signal und Handelshorizont.',
    indicator: 'Indikator',
    direction: 'Richtung',
    horizon: 'Horizont',
    all: 'Alle',
    tradingDays: '{{count}} Handelstage',
    samples: 'Signale',
    successRate: 'Erfolgsquote',
    meanChange: 'Ø Kursentwicklung',
    medianChange: 'Mediane Kursentwicklung',
    overall: 'Gesamtauswertung der aktuellen Auswahl',
    tableLabel: 'Auswertung nach Indikator, Richtung und Horizont',
    loading: 'Signalauswertung wird geladen',
    empty: 'Für diese Auswahl liegen keine abgeschlossenen Auswertungen vor.',
    error: 'Die Signalauswertung konnte nicht geladen werden.',
    unavailable: 'Nicht verfügbar',
    methodology: 'Methodik',
    disclaimer:
      'Historische analytische Ergebnisse sind keine Anlageberatung und garantieren keine zukünftige Entwicklung. Kleine Stichproben können stark schwanken.',
  },
  common: {
    dashboard: 'Übersicht',
    routeLoading: 'Ansicht wird geladen …',
    routeLoadError: 'Die Ansicht konnte nicht geladen werden.',
    retry: 'Erneut versuchen',
    undo: 'Rückgängig',
    close: 'Schließen',
    archived: 'Notiz archiviert',
  },
} as const;

type TranslationShape = { [K in keyof typeof de]: { [P in keyof (typeof de)[K]]: string } };

export const en: TranslationShape = {
  navigation: {
    home: 'Home',
    stocks: 'Stocks',
    evaluations: 'Signal evaluation',
    login: 'Login',
    logout: 'Logout',
    openMenu: 'Open navigation',
    mobileMenu: 'Mobile navigation',
  },
  settings: { open: 'Open settings', language: 'Language', german: 'German', english: 'English' },
  onboarding: {
    title: 'Import securities',
    adminOnly: 'Only administrators may import securities.',
    description:
      'Search by ISIN or symbol. US and XETRA common stocks are supported. Searching does not start an import.',
    search: 'ISIN or symbol',
    find: 'Search',
    loading: 'Processing job',
    noResults: 'No matching supported listing found.',
    review: 'Review import',
    existing: 'Already in the catalog',
    confirmTitle: 'Confirm import',
    cancel: 'Cancel',
    confirm: 'Import and calculate',
    history:
      'Entire available EOD history through today; daily, weekly and monthly indicators and signals using the existing rules.',
    cost: 'Conservative upper bound per attempt: {{count}} provider quota units for prices and calendars, including HTTP retries. At most three job attempts; cached calendars reduce usage. Search and subsequent automatic updates also consume quota.',
    autoUpdate: 'After processing completes, this security joins automatic scheduled updates.',
    quality:
      'Missing data is not fabricated. Incomplete periods and insufficient history are reported. Price basis: existing unadjusted OHLC data; analytical signals are not investment advice.',
    started:
      'The background job was accepted. You may leave this page and return to check its status.',
    jobs: 'Import jobs',
    noJobs: 'No import jobs yet.',
    draft: 'Awaiting confirmation',
    queued: 'Queued',
    running: 'Running',
    waiting: 'Waiting for quota',
    complete: 'Complete',
    partial: 'Complete with limitations',
    failed: 'Failed',
    entities: 'Creating instrument',
    dailyEod: 'Importing daily history',
    dailyIndicators: 'Calculating daily indicators and signals',
    derivedTimeframes: 'Calculating weekly and monthly data',
    finished: 'Processing finished',
    quota:
      'Provider quota is insufficient or cannot currently be verified. The job waits and will be checked again; additional quota is never purchased automatically.',
    updated: 'Last updated',
    finishedNotice: 'Your import job has finished:',
    markRead: 'Mark read',
    open: 'Open analysis',
    notifications: '{{count}} import jobs have finished. Review the results.',
    summary:
      'Daily observations: {{observations}} · rejected observations: {{rejected}} · signals: {{signals}} · incomplete periods: {{incomplete}} · calculation failures: {{failures}} · insufficient history: {{warmup}}',
    error: 'The request could not be completed. Please try again.',
    statusError: 'The current job status could not be loaded. Displayed results may be outdated.',
    planExpired: 'This confirmation expired. Please search again.',
    conflict: 'The listing conflicts with existing instrument metadata. Please request a review.',
    queueBusy:
      'An import is already active or the queue is full. Check your jobs and try again later.',
    searchLimit: 'Please wait a few seconds before searching again.',
    failedHelp:
      'The job could not be processed completely. Have the cause and provider availability checked before another attempt.',
    permissionRevoked: 'The job was not executed because administrator access has been revoked.',
  },
  auth: {
    login: 'Login',
    email: 'Email',
    password: 'Password',
    signIn: 'Sign in',
    invalidCredentials: 'Invalid email or password.',
    loading: 'Checking sign-in …',
    loggingOut: 'Logging out …',
    logoutFailed: 'Logout failed.',
    logoutUnconfirmed: 'You are signed out on this browser. Server logout could not be confirmed.',
    inactivityWarning: 'Your session is about to expire',
    inactivityCountdown: 'You will be signed out due to inactivity in {{seconds}} seconds.',
    keepSession: 'Stay signed in',
    inactivityExpired:
      'You were signed out after five minutes of inactivity. Please sign in again.',
  },
  stock: {
    title: 'Stock analysis',
    select: 'Select stock',
    timeframe: 'Timeframe',
    loading: 'Loading analysis data',
    entriesError: 'Stocks could not be loaded.',
    analysisError: 'Analysis data could not be loaded.',
    noEntries: 'No supported stocks available.',
    source: 'Source',
    unavailable: 'Not available',
    updated: 'Updated',
    stale: 'Data may be stale',
    noObservations: 'No market data is available for this period.',
    signal: 'Analytical signal',
    lastUpdate: 'Last updated',
    recent: 'Recent observations',
    partial: 'Market data is available, but some indicators are missing.',
    disclaimer:
      'Analytical signal – not investment advice. This information is for analysis only and does not guarantee future performance.',
    chartLabel: 'Price and indicator history for {{symbol}}',
    chartSeries: 'Select data series',
    chartSignals: 'Show signals',
    chartTriggers: 'Triggered by',
    chartBuy: 'Buy',
    chartSell: 'Sell',
    chartSuperSignals: 'SUPER CALL / SUPER PUT',
    inspectChart: 'Select chart data point',
    enterChartFullscreen: 'Show chart fullscreen',
    exitChartFullscreen: 'Exit chart fullscreen',
    signalHistory: 'Signals in the selected range',
    noSignals: 'No signals are available for this range.',
    instrumentPanel: 'Indices and stocks',
    favorites: 'Favorites',
    filterFavorites: 'Filter favorites',
    noFavorites: 'No favorites available.',
    addFavorite: 'Add to favorites',
    removeFavorite: 'Remove from favorites',
    favoriteUpdateFailed: 'The favorite could not be saved.',
    indices: 'Indices',
    noIndices: 'No indices available.',
    stockPanel: 'Stocks',
    filterStocks: 'Filter stocks',
    openStockPanel: 'Open stock panel',
    closeStockPanel: 'Close stock panel',
    noStockMatches: 'No matching stocks found.',
    longSignal: 'BUY SIGNAL',
    shortSignal: 'SELL SIGNAL',
    leavingLongSignal: 'LONG SIGNAL ENDED',
    leavingShortSignal: 'SHORT SIGNAL ENDED',
    noCurrentSignal: 'NO CURRENT SIGNAL',
    superCall: 'SUPER CALL',
    superPut: 'SUPER PUT',
    provisional: 'provisional',
    provisionalNotice:
      'Contains provisional hourly values from delayed live quotes (high/low approximated); they are replaced by the official values overnight.',
    noSuperSignal: 'NO SUPER SIGNAL',
    combinedSignal: 'Combined signal',
    infoSignal: 'Info',
    timeframe30m: '30 min',
    timeframe3h: '3 hours',
    timeframe6h: '6 hours',
    timeframe1h: 'Hourly',
    timeframe1d: 'Daily',
    timeframe1w: 'Weekly',
    timeframe1mo: 'Monthly',
  },
  dashboard: {
    favorites: 'Favorites',
    indices: 'Indices',
    stocks: 'Stocks',
    loading: 'Loading signals',
    empty: 'No daily signals available.',
    emptyCombined: 'No SUPER signals available.',
    showSingleSignals: 'Show single-indicator signals',
    error: 'Signals could not be loaded.',
    stale: 'Signal may be stale',
    pagination: 'Pages for {{section}}',
    index: 'Index',
    openDetails: 'Open details for {{name}} ({{symbol}})',
  },
  providerStatus: {
    title: 'EODHD API quota',
    loading: 'Loading API quota',
    healthy: 'API quota available',
    warning: 'API quota is running low',
    exhausted: 'API quota is exhausted',
    unavailable: 'API quota cannot currently be checked.',
    used: 'Used today',
    remaining: 'Remaining today',
    dailyLimit: 'Daily limit',
    extra: 'Extra quota',
    previousUsageDate:
      "EODHD still reports the status from {{date}}. According to the provider, today's usage starts with the first billable request.",
    timestamps: 'Checked: {{checked}} · Daily reset: {{reset}}',
    unknown: 'unknown',
  },
  evaluation: {
    title: 'Signal evaluation',
    description: 'Historical price development by analytical signal and trading horizon.',
    indicator: 'Indicator',
    direction: 'Direction',
    horizon: 'Horizon',
    all: 'All',
    tradingDays: '{{count}} trading days',
    samples: 'Signals',
    successRate: 'Success rate',
    meanChange: 'Mean price change',
    medianChange: 'Median price change',
    overall: 'Overall result for the current selection',
    tableLabel: 'Evaluation by indicator, direction, and horizon',
    loading: 'Loading signal evaluation',
    empty: 'No completed evaluations are available for this selection.',
    error: 'The signal evaluation could not be loaded.',
    unavailable: 'Not available',
    methodology: 'Methodology',
    disclaimer:
      'Historical analytical results are not investment advice and do not guarantee future performance. Small samples can vary substantially.',
  },
  common: {
    dashboard: 'Dashboard',
    routeLoading: 'Loading view …',
    routeLoadError: 'The view could not be loaded.',
    retry: 'Retry',
    undo: 'Undo',
    close: 'Close',
    archived: 'Note archived',
  },
};

export type Locale = 'de' | 'en';
export type TranslationKey = {
  [S in keyof typeof de]: `${S & string}.${keyof (typeof de)[S] & string}`;
}[keyof typeof de];
export const translations = { de, en };
